import React from "react"

import BaseSvgIcon from "../Base"

const Check = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 -960 960 960">
      <g>
        <path d="M382-240 154-468l57-57 171 171 367-367 57 57z" />
      </g>
    </BaseSvgIcon>
  )
}

export default Check
